export default __webpack_public_path__ + "static/media/database.af7a903c.svg";